import { Roster, DriverRoster, SquadRoster } from "model/Roster/Roster";
import {
  RosterScope,
  DRIVER_SCOPE,
  SQUAD_SCOPE,
} from "model/Roster/RosterScope";

export interface IMatchTeams<
  TScope extends RosterScope,
  TRoster extends Roster
> {
  scope: TScope;
  rosters: TRoster[];
}

export type MatchDrivers = IMatchTeams<
  typeof DRIVER_SCOPE,
  DriverRoster | string
>;
export type MatchSquads = IMatchTeams<typeof SQUAD_SCOPE, SquadRoster | string>;
export type MatchTeams = MatchDrivers | MatchSquads;

export const getNumTeams = (teams: MatchTeams) => teams.rosters.length;
